import { SocialExportUploadItemCard as SocialExportUploadItemCardLayout } from '@app/modules/social-export/publish/SocialExportUploadItemCard';
import { FragmentSocialUploadItemDto } from '@app/modules/fragments/fragment.types';
import { useSocialExportUploadItemCardActions } from './useSocialExportUploadItemCardActions';

interface SocialExportUploadItemCardProps {
  upload: FragmentSocialUploadItemDto;
}

/**
 * Fragment social upload card: delegates layout to shared social-export card.
 */
export function SocialExportUploadItemCard({ upload }: SocialExportUploadItemCardProps) {
  const { trigger: actionsTrigger, menuAndDialog: actionsMenuAndDialog } =
    useSocialExportUploadItemCardActions({ upload });

  return (
    <SocialExportUploadItemCardLayout
      upload={upload}
      actionsTrigger={actionsTrigger}
      actionsMenuAndDialog={actionsMenuAndDialog}
    />
  );
}
